<template>
  <div class="wrapper" style="background-color: white;">
    <img src="/static/images/wx-share-logo.jpg" alt="" style="width:0px; height:0px;">
    <div v-show="loading" class="page-loading" style="width:100%;height:100%;position:fixed;top:0;background:#000000;z-index:10000;opacity:0.8;max-width:640px">
      <div class="loading-box" style="box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%);">
        <div class="loading-img"></div>
      </div>
    </div>

    <!--结构化引导-->
    <div class="new-user-guide" v-show="loading === false && showguide === true" @click="hideNewUserGuide">
      <div class="guide-menu" @click="hideNewUserGuide"></div>
      <div class="guide-img">
        <img src="../../../static/images/new-user-guide.png" alt="">
      </div>
    </div>

    <!-- 目录-打开-->
    <div id="mulu" v-show="showmenu">
      <div class="toolsbar-mune">
        <div class="toggle-menu-wrap" @click="toggleMenu">
          <span class="cancle-btn"></span>
        </div>
        <div class="header-menu-wrap">
          <span class="options clicked header-menu" style="height: 40px;">目录</span>
        </div>
      </div>

      <!--目录-->
      <div class="notice-menu">
        <div class="bottom-color" style="max-width: 640px;">
          <div class="left-side-page">
            <div class="catalog-cont">
              <ul>
                <template v-for="c in titles">
                  <li v-if="c.code && c.code.split('.').length<=7" :style="indentChild(c.code)" v-show="c.isshow && c.title !== ''" id="title_{{c.code}}">
                    <a href="javascript:;" :class="{'expand': c.code.split('.').length<=2}">
                      <span @click="showTitleChild(c)" :class="{'open-caret-right': c.code.split('.').length<=2, 'close-caret-right': c.code.split('.').length>2}" v-if="c.haschild && !c.showchild"></span>
                      <span @click="showTitleChild(c)" :class="{'open-caret': c.code.split('.').length<=2, 'close-caret': c.code.split('.').length>2}" v-if="c.haschild  && c.showchild"></span>
                      <span class="no-caret" v-if="!c.haschild"></span>
                      <span class="caret-pad" @click="titleIntoView(c.code + '-0')">
                    <span class="title-xuhao" v-if="detail.datasrc === 'IRM'">
                      <span v-if="c.tqaindex >= 0">
                        {{ c.tqaindex + 1 }}、
                      </span>
                    </span>
                    {{{ c.title }}}
                  </span>
                    </a>
                  </li>
                </template>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--目录-关闭-->
    <div class="toolsbar-mune" @click="toggleTitle" v-show="!showmenu">
      <div class="toggle-menu-wrap" @click="toggleMenu">
        <span class="sidebar-btn"></span>
      </div>
      <div class="notice-title blue"><strong id="detail-title">{{ detail.fulltitle | formatTitle }}</strong></div>
      <div class="header-toggle-icon" v-if="detail.fulltitle.length > 33">
        <div class="toggle-icon toggle-down-arrow"></div>
      </div>
    </div>

    <!--主体-->
    <div class="my-container qa-cont" v-show="!showmenu && !showComments">
      <div class="article-content notice-content qa-notice-content">
        <div class="company-statement" v-if="topPage == 1 || topPage == 0">
          <div class="article-detail">
            <template v-if="detail.content !== ''">
              <p v-for="content in detail.content.split('\n')" style="width: 100%; margin: 0 auto; margin-left: 3px; margin-right: 0;" id="0-{{$index}}">{{ content }}</p>
            </template>
          </div>
        </div>

        <!-- <template v-for="c in detail.child" track-by="$index" v-if="$index <= pages * 3"> -->
        <template v-for="c in detail.child" track-by="$index" v-show="$index <= (bottomPage*3-1) && $index > (topPage-1)*3-1">
          <template v-if="c.title">
            <p class="title-a" id="{{c.code}}-0" :style="indentChild(c.code)" v-if="c.title"> {{ c.title }} </p>
            <template v-if="c.content && c.content !== '' && c.content !== ' ' && c.content !== '无'">
              <p v-for="con in c.content.split('\n')" style="width: 94%; margin: 0 auto; text-indent: 20px" id="{{c.code}}-{{$index}}" class="tttt"> {{ con }} </p>
            </template>
          </template>

          <table class="catalog-qa" v-if="c.que">
            <tbody style="width: 100%">
            <!--问题-->
            <tr style="display: block">
              <td class="qa-left-w" style="width: 1.68rem; font-size: 14px; color: #0D65D8">
                <template v-if="detail.datasrc === 'IRM'">
                   <span style="float: right; padding: 0;text-align: right;">
                    {{c.qaindex + 1}}、
                  </span>
                </template>
                <template v-if="detail.datasrc !== 'IRM'">
                  <span class="catalog-icon cata-qa-q"></span>
                </template>
              </td>
              <td id="{{c.code}}-0">
                <template v-if="detail.datasrc === 'IRM'">
                  <span class="catalog-icon cata-qa-q" style="margin: 0.18rem 5px 2px 0px;"></span>
                </template>
                <span class="catalog-qa-date" style="margin-right: 0" v-if="c.qer || c.time">(</span>
                <span class="catalog-qa-date" v-if="c.qer">{{ c.qer | formatPhone }}:</span>
                <span class="catalog-qa-date" v-if="c.time" style="margin-right: 0">{{ c.time | timeFilter }}</span>
                <span class="catalog-qa-date" v-if="c.qer || c.time">)</span>
                <div class="catalog-q-cont" style="margin-right: 6px">
                  <span class="catalog-qa-blue" style="display: inline-block">
                    {{ c.que }}
                  </span>
                  <template v-for="t in c.tag">
                    <span class="catalog-q-tag" v-if="t !== ''">
                      {{ t }}
                    </span>
                  </template>
                </div>
              </td>
            </tr>

            <!--回答-->
            <tr v-for="d in c.answers" style="display: block">
              <template v-if="detail.datasrc === 'IRM' && d.ans !== ''">
                <td v-if="detail.datasrc === 'IRM'" style="width: 1.68rem; text-align: right; color: #0D65D8"></td>
              </template>
              <template v-if="detail.datasrc !== 'IRM'">
                <td style="width: 31px">
                  <span class="catalog-icon cata-qa-a"></span>
                </td>
              </template>
              <td v-if="d.ans !== ''" id="{{c.code}}-{{$index+1}}">
                <template v-if="detail.datasrc === 'IRM'">
                  <span class="catalog-icon cata-qa-a" style="margin: 0.18rem 5px 2px 0px;"></span>
                </template>
                  <span class="catalog-qa-date" style="margin-right: 0" v-if="d.time || $.trim(d.rername) !== ''">(</span>
                  <span class="catalog-qa-date" v-if="d.rername && d.rername !== ' '">{{d.rername | formatPhone}}:</span>
                  <span class="catalog-qa-date" v-if="d.time" style="margin-right: 0px">{{d.time | timeFilter}}</span>
                  <span class="catalog-qa-date" v-if="d.time || $.trim(d.rername) !== ''">)</span>
                  <div class="catalog-q-cont" style="display: inline-block; margin-right: 6px">
                     <!-- <span v-for="content in d.ans.split('\n')" id="{{c.code}}-{{$index}}"> -->
                     <span v-for="content in d.ans.split('\n')">
                        <span>{{content}}</span>
                        <br style="content: '';margin: 12px 0;">
                     </span>
                  </div>
              </td>
            </tr>
            </tbody>
          </table>
        </template>
      </div>
    </div>

    
    <div class="my-container" v-show="showComments">
        <div class="comment-detail">
          <div class="comment-title">
           <p class="comment-all">全部评论</p><!--  <a class="comment-my" href="javascript:;">我的评论</a>  -->
           <p class="comment-sort">{{cpwtotal}}条评论</p>
          </div>
          <div class="comment" v-for="item in commentList">
            <div class="common-avatar">
            <img src="/static/images/user.png" width="100%" height="100%">

          </div>
          <div class="comment-block">
            <p class="comment-user">
              <span class="comment-username" v-if="item.user"> {{item.user.username}} </span>
              <span class="comment-username" v-else> 匿名用户 </span>
            <span class="footer-zan"> <i class="c-share-icon" @click.stop="zan(item.id, $event)"></i><span class="u-num">{{item.zan_cnt}}</span></span>
            </p>
             <div class="comment-content">{{item.content}}
             </div>
             <div class="comment-operate">
                <span class="J_Vote comment-operate-item comment-operate-up">{{item.updtime | date}}</span>
                <span class="J_Reply comment-operate-item"> <a href="javascript:;" @click="commentinput = true, pid = item.id, content = ''">回复</a> </span>
            </div>
            <div class="comment-reply-ctn comment-reply-item" >
              <ul>
                <li v-for="i in item.replys" track-by="$index" v-if="$index < item.showall">
                  <p class="comment-text">
                    <span class="c-username" v-if="i.user"> {{i.user.username}} </span>
                    <span class="c-username" v-else>匿名用户</span>
                    {{i.content}}
                  </p>
                  <div class="reply-operate reply-operate-hot">
                      <span class="J_Vote reply-operate-item reply-up"><i class="c-share-icon" @click.stop="zan(i.id, $event)"></i><span>{{i.zan_cnt}}</span></span>
                        <span class="J_Reply reply-operate-item"></span>  <span>{{i.updtime | date}}</span>
                    </div>
                </li>
                <!-- <li v-for="y in item.replys" track-by="$index" v-if="showall">
                  <p class="comment-text">
                    <span class="c-username" v-if="y.user"> {{y.user.username}} </span>
                    <span class="c-username" v-else>匿名用户</span>
                    {{y.content}}
                  </p>
                  <div class="reply-operate reply-operate-hot">
                      <span class="J_Vote reply-operate-item reply-up">赞<i class="staticAdd" @click.stop="zan(i.id, $event)">{{i.zan_cnt}}</i></span>
                        <span class="J_Reply reply-operate-item"></span>  <span>{{y.updtime | date}}</span>
                    </div>
                </li> -->

                <li class="view-more hidden" v-if="item.replys.length > 2 && item.showall !== 8">
                  <a class="btn-block text-center btn-comment-expand" @click="item.showall = 8">查看全部<span class="nume">{{item.replys.length}}</span>条回复  </a>
                </li>
              </ul>
              </div>
          </div>
          </div>
          </div>

          <div class="comment-more">
          <a href="javascript:;" v-if="commentList.length !== cpwtotal">加载更多评论中...</a>
          <a href="javascript:;" v-if="commentList.length == cpwtotal && cpwtotal !== 0">评论已全部加载</a>
          </div>
          <div class="comment-no" v-if="cpwtotal == 0">
          暂无评论，快来添加一个吧！
          </div>
          <div class="comment-no"></div>
        </div>
    <!--评论栏-->
    <div class="footer-comment">
      <span class="footer-text"><a href="javascript:;" @click="commentinput = true, content= '',pid = 0"><i class="comment-icon"></i>评论一下</a></span>
      <span class="footer-zan" v-show="!showComments"> <a href="javascript:;" @click="showComments = true,loadcomment()"><span class="qinp"><i></i>{{cpwtotal}}</span></a>
      </span>
      <span class="footer-zan" v-show="showComments"> <a href="javascript:;" @click="showComments = false"><span class="text"><i></i>返回原文</span></a>
      </span>
    </div>
    <!--评论弹窗-->
    <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" style="display: block;" v-show="commentinput" @click.self="commentinput = false">
    <div class="comment-content">
      <div class="comment-content-tag">
         <div class="login-close">
           <a class="delete-icon" href="javascript:;" @click="commentinput = false"></a>
        </div>
          <div class="comment-reply">
           <textarea cols="" rows="2" class="input-a" placeholder="输入发表内容" v-model="content"></textarea>
           <span class="anonymous" @click="anonym == 1 ? anonym = 0:anonym = 1">
               <label class="el-checkbox mar">
                <span class="el-checkbox-input" :class="{'is-checked':anonym === 1}"><span class="el-checkbox-inner"></span>
                </span>
                <span class="el-checkbox-label">匿名评论</span>
                </label>
             </span>
           <a class="btn-Publish" href="javascript:;" @click="commentinput = false,addComment(1, md5, params.stype, detail.publishDate)">发表</a>
          </div>
      </div>
    </div>
     </div>
    <div v-if="commentinput" class="ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all" id="ui-datepicker-div"></div>
    <div v-if="commentinput" class="modal-backdrop fade in"></div>
    <!--页脚-->
    <div class="footer-app">
      <a class="footer-logo-ios"></a>
      <span class="footer-text">IBDATA<br/>人工智能和大数据驱动的投研首选平台</span>
      <a class="footer-btn" @click="downloadApp">下载应用</a>
    </div>

    <!--微信绑定弹框-->
    <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" v-show="tipGoBind">
      <div class="binding-content">
        <a class="binding-logo"></a>
        <div class="binding-text">
          立即绑定IBDATA账号<br/>成为金融分析高手
        </div>
        <div class="binding-bot">
          <a class="binding-no-btn" @click="tipGoBind = false">暂不绑定</a>
          <a class="binding-btn" @click="goBindPage">立即绑定</a>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade in" v-show="tipGoBind"></div>
    <!-- / 微信绑定弹框-->
  </div>
</template>

<script>
  import { apiUrl, alert } from '../../helper'
  import $ from 'jquery'
  import commentMix from './commentMix'
  import userMix from '../../common/userMix'
  import wxshareMix from '../../common/wxshareMix'
  import noticeMix from '../../common/noticeMix'
  import searchMix from '../../common/SearchMix'

  export default {
    name: 'qaView',
    mixins: [userMix, commentMix, wxshareMix, noticeMix, searchMix],
    data () {
      return {
        md5: '',
        detail: {},    // 接口数据
        titles: [],
        id: null,         // id
        showmenu: false,   // 是否显示目录
        loading: false,    // 加载动画
        hideFooter: true,
        // showAllTitle: false,   // 展开全部目录
        pages: 1,      // 分页渲染，渲染都第几页
        topPage: 1,     //上分页
        bottomPage: 1,  //下分页
        allPageNum: 0,  // 当前公告别分成多少页
        allId: [],
        shareParams: {   // 分享所需变量
          allId: []
        }
      }
    },
    ready () {
      if (this.hideFooter) {
        $('footer.footer').css({'display': 'none'})
      }
      $('.wrapper').css('min-height', $(window).height() - 100)
    },
    created () {
      $('meta')[2].content = 'width=device-width, initial-scale=1'
    },
    route: {
      data ({ to }) {
        if (!this.currentuser) {
          this.wxcode = this.getQueryString('code')
          if (this.wxcode) {
            this.wxlogin(this.wxcode)
          } else {
            this.getProfile(to.query)
          }
        }
        if (this.currentuser) {
          this.params.id = to.params.id
          this.params.stype = to.query.stype
          this.params.tcode = to.query.tcode
          this.params.pdate = to.query.pdate
          this.params.idxname = to.query.idxname
          this.params.uidUrl = to.query.uid
          this.params.share = to.query.share
          this.params.plat = to.query.plat
          this.params.ts = to.query.ts
          this.params.sid = to.query.sid
          this.params.ruid = to.query.ruid
          this.params.forceupd = to.query.forceupd
          // this.params.desc = to.query.desc
          let descs = window.location.href.split('&')
          for (var i=0,len=descs.length; i<len; i++) {
            let str = descs[i]
            if (str.indexOf('desc=') == 0) {
              // this.params.desc = decodeURI(str.split('=')[1])
              this.params.desc = decodeURIComponent(str.split('=')[1])
              break;
            }
          }
          console.log(this.params.desc)

          this.titles = []
          this.getDetail()   // 获取详情noticeDetail接口返回的数据

          // ==========================================
          let that = this
          jQuery(window).bind('scrollstop', function () {
            console.log('滚动事件结束')
            // that.cpwpage = that.cpwpage + 1
            // if (that.cpwpage <= Math.ceil(that.cpwtotal / 10)) {
            //   that.getCommentList(1, that.params.id)
            // }
            // 1. 获取所有ID
            let _allId = []
            if (that.shareParams.allId.length === 0) {
              _allId = that.getAllId( that.shareParams.allId )
            } else {
              _allId = that.shareParams.allId
            }
            let itemID = that.getInnerWindowId(_allId)
            if (itemID.split('-')[1] !== 0) {
              itemID = itemID.split('-')[0] + '-0'
            }
            let stype = that.params.stype

            let title = ''
            if (!that.params.desc || that.params.desc == '') {
              title = that.detail.fulltitle
            } else {
              title = that.params.desc
            }

            let desc = that.getNoticeShareDesc(stype, itemID)
            that.shareNotice(stype, itemID, title, desc)
          })

          this.commentList = []
          this.commentinput = false
          this.showComments = false
          this.getcommentc
          this.md5 = this.params.id
        }
      }
    },
    methods: {
      loadcomment: function () {
        if (this.commentList.length == 0) {
          this.getCommentList(1, 1,this.params.id)
        }
      },
      getDetail () {
        console.log('getDetail')
        this.loading = true
        let query = {
          'id': this.params.id,
          'stype': this.params.stype,
          'pdate': this.params.pdate
        }
        query.uid = parseInt(this.params.uidUrl)
        query.share = this.params.share
        query.plat = this.params.plat
        query.sid = this.params.sid
        query.ruid = this.params.ruid
        $.ajax({
          url: apiUrl('/V1.0.0/notice/noticedetail'),
          method: 'post',
          dataType: 'json',
          data: JSON.stringify(query)
        }).done((response) => {
          this.loading = false
          if (response.status === 0) {
            let details = response.data
            this.detail = response.data
            this.cpwtotal = this.detail.commentcount
            this.fulltitle = this.detail.fulltitle
            let titles = []
            let i = 0
            console.log(details)
            for (let child of details.child) {
              let isshow = true
              if (child.code && child.code.split('.').length > 3) {
                isshow = false
              }
              let haschild = false
              var rgxp = new RegExp('^' + child.code + '\.\\d+$', 'g')
              if (details.child[i + 1] && details.child[i + 1].code && details.child[i + 1].code.match(rgxp)) {
                haschild = true
              }
              let showchild = false
              if (child.code && child.code.split('.').length <= 2) {
                showchild = true
              }
              let _title = ''
              let tag = ''
              if (child.title) {
                _title = child.title
                tag = 'ml'
              }
              if (child.que) {
                _title = child.que
                tag = 'qa'
              }
              let index = this.getIndex(child, details.child)   // 获取其在数组中的索引
              titles.push({
                'title': _title,
                'code': child.code,
                'isshow': isshow,
                'haschild': haschild,
                'showchild': showchild,
                'index': index,
                'tag': tag
              })
              this.shareParams.allId.push(child.code + '-0')
              let idx = 1
              if (child.title && child.content !== '' && child.content !== ' ') {  // 标题
                for (let c of child.content) {
                  this.shareParams.allId.push(child.code + '-' + idx)
                  idx++
                }
              } else if (child.que) {  // 问题
                for (let c of child.answers) {
                  this.shareParams.allId.push(child.code + '-' + idx)
                  idx++
                }
              }
              i++
            }

            console.log('>>> details.child')
            console.log(details.child)
            // 主体序号
            let childs = details.child
            let qaChilds = []       // 问题
            let len = childs.length
            for (let i = 0; i < len; ++i) {
              childs[i].index = i + 1
              if (childs[i].que) {
                qaChilds.push(childs[i])
              }
            }
            for (let j = 0; j < qaChilds.length; j++) {
              qaChilds[j] = Object.assign({}, qaChilds[j], {'qaindex': j})
            }
            // 内容中问题序号
            for (let i = 0; i < len; ++i) {
              for (let j = 0; j < qaChilds.length; ++j) {
                if (childs[i].que === qaChilds[j].que) {
                  childs[i].qaindex = qaChilds[j].qaindex
                  break
                }
              }
            }
            // 目录序号
            let allTitle = titles
            for (let i = 0; i < allTitle.length; ++i) {
              for (let j = 0; j < qaChilds.length; ++j) {
                if (allTitle[i].title === qaChilds[j].que) {
                  allTitle[i].tqaindex = qaChilds[j].qaindex
                  break
                }
              }
            }
            titles = allTitle
            this.detail = details
            this.genTitleTree(titles)


            // ------------------------------------------------------------------- 页头操作
            this.$nextTick(function () {
              this.toggleHeader()
              this.setContMarginTop()
              this.getwxsign()    // 微信签名
              if (!this.params.tcode) {
                $(window).scrollTop(0)
              }
              // 微信分享
              let _allId = []   // 获取所有id
              if (this.shareParams.allId.length === 0) {
                _allId = this.getAllId( this.shareParams.allId )
              } else {
                _allId = this.shareParams.allId
              }
              // console.log(_allId)
              let itemID = this.getInnerWindowId(_allId)    // 获取滚动事件结束时存在可是区域内的第一个可用Id
              // console.log(itemID)
              if (itemID.split('-')[1] !== 0) {
                itemID = itemID.split('-')[0] + '-0'
              }
              let stype = this.params.stype
              let title = ''
              if (!this.params.desc || this.params.desc == '') {
                title = this.detail.fulltitle
              } else {
                title = this.params.desc
              }
              this.changeMetaTitle(title);

              let desc = this.getNoticeShareDesc(stype, itemID)
              this.shareNotice(stype, itemID, title, desc)
            })


            // ------------------------------------------------------------------ 分页加载
            let allPageNum = Math.ceil(this.detail.child.length / 3)
            if (this.params.tcode && this.params.tcode !== '' && this.params.tcode !== 'undefined-1') {   // 有id
              let id = this.params.tcode.split('-')[0]
              let idx = 0
              let pages = 0
              let that = this
              for (let i = 0; i < this.detail.child.length; ++i) {  // 获取包含改tcode的child所在的索引
                if (this.detail.child[i].code === id) {
                  idx = i
                  break
                }
              }

              pages = Math.ceil(idx / 3) // 分享定位id所在的页面
              this.pages = pages
              this.topPage = pages
              this.bottomPage = pages

              console.log(allPageNum)
              if(this.params.tcode){
                let tcode = this.params.tcode
                setTimeout(function () {
                  if (document.getElementById(tcode)) {
                    document.getElementById(tcode).scrollIntoView()
                    let scrollTop = $(window).scrollTop() - 30
                    $(window).scrollTop( scrollTop )
                  }
                  // else {
                  //   $(window).scrollTop( 30 )
                  // }
                }, 100);
              }

              let timer = setInterval(function() {
                // 向上分页
                if (that.detail.child.length > 3 && that.topPage > 1) {
                  that.topPage--
                  console.log('top-page:' + that.topPage)
                }
                // 向下分页
                if (that.detail.child.length > 3 && that.bottomPage < allPageNum) {
                   that.bottomPage++
                   console.log('bottom-page:' + that.bottomPage)
                }

                if (that.detail.child.length < 3) {
                  window.clearInterval(timer);
                }
                if (that.topPage == 1 && that.bottomPage == allPageNum) {
                  window.clearInterval(timer);
                  console.log('渲染到最后一页')
                  console.log(that.bottomPage)
                  console.log(that.allPageNum)
                }
              }, 100);

            } else {
              let that = this
              that.topPage = 1
              that.bottomPage = 1
              let timer = setInterval(function() {
                if (that.detail.child.length > 3 && that.bottomPage < allPageNum) {
                  that.bottomPage++
                } else {
                  window.clearInterval(timer);
                  console.log('渲染到最后一页')
                  console.log(that.bottomPage)
                  console.log(that.allPageNum)
                }
              }, 100);
            }
            // -----------------------------------------------
          }
        }).fail((response) => {
          this.loading = false
          alert('请求失败')
        })
      },
      getIndex (item, arr) {
        for (let i = 0; i < arr.length; ++i) {
          if (item === arr[i]) {
            return i
          }
        }
      },
      setContMarginTop () {
        let detailH = $('#detail-title').height()
        if (detailH > 0) {
          let detailTitleH = $('#detail-title').height()
          let noticeTitleH = $('.notice-title').height()
          let marginTop = ''
          if ($('.header-toggle-icon').height()) {
            noticeTitleH += 8
            marginTop = noticeTitleH.toString() + 'px'   // 页头高度
          } else {
            marginTop = detailTitleH.toString() + 'px'   // 页头高度
          }
          $('.my-container').css({'marginTop': marginTop})
        }
      },
      toggleHeader () {
        let header = $('.toolsbar-mune')
        // 滚动监听
        let p = $(window).scrollTop()  // 滚动条距离顶部的距离
        let t = p
        let that = this
        $(window).off('scroll').on('scroll',function () {   // 绑定滚动的监听事件
          if (($(window).scrollTop() + $(window).height()) >= $(document).height() && that.showComments) {
            let page = that.cpwpage + 1
            if (page <= Math.ceil(that.cpwtotal / 10)) {
              that.getCommentList(page, 1, that.md5)
            }
          }

          p = $(this).scrollTop()  // 滚动后滚动条距顶部的距离
          // 下滚, 隐藏页眉
          if (t <= p) {
            if (header.hasClass('slideDown')) {
              header.removeClass('slideDown')
              header.addClass('slideUp')
            } else {
              header.addClass('slideUp')
            }
          } else {    // 上滚， 显示页眉
            if (header.hasClass('slideUp')) {
              header.removeClass('slideUp')
              header.addClass('slideDown')
            } else {
              header.addClass('slideDown')
            }
          }
          t = p
        })
      },
    },
    filters: {
      timeFilter (param) {
        param = param.split(' ')[0]
        return param
      },
      formatPhone (phone) {
        if ((/^1(3|4|5|7|8)\d{9}$/.test(phone))) {  // 对手机号正则匹配
          // return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')   // 手机号中间四位用星号替换
          if (this.detail.datasrc === 'IRM') {
            return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')   // 手机号中间四位用星号替换
          } else {
            return phone
          }
        } else if (/^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test(phone)) {
          let c = phone.split('@')
          // console.log(c)
          let c1 = c[0].substr(3)  // 截取下标3开始的字符串
          // console.log(c1)
          let xing = ''
          for (let i = 0; i < c1.length; i++) {
            xing += '*'
          }
          let newemail = c[0].substr(0, 3) + xing + '@' + c[1]
          return newemail
        } else {   // 如果不是手机号, 显示原文本
          return phone
        }
      }
    }
  }
</script>

<style scoped>
  /*@import "../../../static/css/style.css";*/
  .catalog-qa {
    /*width: 94% !important;*/
    margin: 0px auto;
  }

  .catalog-q-cont {
    font-size: 0.7rem;
    line-height: 1.1rem;
  }

  .qa-cont {
    overflow-y: auto;
    overflow-x: hidden;
  }

  .notice-content {
    padding-bottom: 75px;
  }

  td {
    border: none;
  }

 /* .footer-text {
    font-size: 13px;
    margin-left: 0px !important;
  }*/

  .footer-btn {
    /*font-size: 15px;*/
    padding: 0px 3px !important;
  }

  .bottom-color {
    z-index: 1000;
  }

  .left-side-page {
    width: 100%;
    background: #F8F8F8;
  }

  .footer-app {
    z-index: 1001;
  }


  .catalog-cont {
    padding:10px 6px 20px 10px;
    padding-bottom: 120px;
    overflow-x: hidden;
    padding-bottom: 75px;
  }

  .catalog-cont ul li {
    display: block;
    overflow: hidden;
    margin: 10px 0;
    line-height: 28px;
  }

  .catalog-cont ul li a {
    color: #000;
  }

  .catalog-cont ul li > .expand {
    color: #3270ad;
  }

  .notice-title {
    width: 85%;
  }

  .catalog-qa-date {
    /*float: left;*/
    margin-top: -11px;
  }

  .caret-pad {
    /*float: right;*/
    /*width: 95%;*/
    font-weight: 600;
    line-height: 1.8em;
  }

  /*#dialog {*/
    /*display: none !important;*/
  /*}*/

  .delete-content {
    display: none;
  }

  .title-a {
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 10px;
    background: linear-gradient(to right, #d9d9d9, #ffffff);
    line-height: 1.5em;
    padding: 2px 0;
    text-indent: 1px;
    padding-left: 3% !important;
    margin-left: 0 !important;
    margin-right: 0;
    margin-top: 10px;
  }
  .catalog-q-tag {
    padding: 0px 5px;
    display: inline-block;
    line-height: 18px;
  }

  .loading-box {
    top: 43% !important;
  }
  .loading-img {
    width: 35px;
    height: 35px;
    background-image: url('../../../static/images/loading2.gif');
    background-size: cover;
  }

  .catalog-qa-date {
    display: inline-block;
    height: 22px;
  }

  .toolsbar-mune {
    height: auto;
    min-height: 40px;
  }

  .notice-title {
    margin-top: 8px;
    margin-bottom: 3px;
    width: 88%;
    float: right;
    text-align: left;
    font-size: 16px;
    height: auto;
  }

  /* -------------------------------------------- 结构化引导 */
  .new-user-guide {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1999;
    background: rgba(0,0,0, 0.7);
  }

  .guide-img,
  .guide-menu,
  .guide-img img {
    position: relative;
  }

  .guide-img {
    width: 85%;
    margin: 20% auto;
  }

  .guide-img img {
    max-width: 100%;
  }

  .guide-menu {
    position: absolute;
    top: 4px;
    left: 7px;
    width: 34px;
    height: 34px;
    background-color: #FFFFFF;
    border-radius: 5px;
    opacity: .7;
  }
  /* -------------------------------------------- 页眉*/
  .slideUp {
    /* -webkit-transform: translateY(-100px);
         transform: translateY(-100px);*/
    -webkit-transform: translateY(-100px);
    -ms-transform: translateY(-100px);
    -o-transform: translateY(-100px);
    transform: translateY(-100px);
    /*transition: transform .5s ease-out;*/
    -webkit-transition: transform .5s ease-out;
    -o-transition: transform .5s ease-out;
    transition: transform .5s ease-out;
  }

  .slideDown {
    /*-webkit-transform: translateY(0);
        transform: translateY(0);*/
    -webkit-transform: translateY(0);
    -ms-transform: translateY(0);
    -o-transform: translateY(0);
    transform: translateY(0);
    /*transition: transform .5s ease-out;*/
    -webkit-transition: transform .5s ease-out;
    -o-transition: transform .5s ease-out;
    transition: transform .5s ease-out;
  }

  .notice-share-logo {
    display: none;
  }

  .header-toggle-icon {
    width: 100%;
    float: right;
    height: 20px;
  }

  .header-toggle-icon .toggle-icon {
    background-size: cover;
    height: 16px;
    width: 21px;
    margin: 0 auto;
  }

  .header-toggle-icon .toggle-up-arrow {
    background-image: url("../../../static/images/toggle-up-arrow.svg");
  }

  .header-toggle-icon .toggle-down-arrow {
    background-image: url("../../../static/images/toggle-down-arrow.svg");
  }

  .toggle-menu-wrap {
    padding: 0;
    width: 11%;
    float: left;
    height: 40px;
    overflow: hidden;
  }

  .header-menu-wrap {
    width: 88%;
    float: right;
    text-align: left;
  }

  .header-menu-wrap .header-menu {
    width: auto;
    margin-left: 35%;
  }

  .catalog-cont ul li a:active .caret-pad {
    background-color: #d7dbf7;
  }

  .my-container {
    /*position: static;*/
    position: relative;
    top: 0;
  }
  .article-detail {
    margin-top: 0;
  }

  .modal {
    display: block;
  }
</style>



/** WEBPACK FOOTER **
 ** QaNoticeDetail.vue?1e282b79
 **/